export default __webpack_public_path__ + "static/media/ChevronRight.21e03ac0.svg";